import script from "./PlanosAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanosAdministrar.vue?vue&type=script&setup=true&lang=js"

import "./PlanosAdministrar.vue?vue&type=style&index=0&id=7996285e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7996285e"]])

export default __exports__